export var ActorType;
(function (ActorType) {
    ActorType["CLIENT"] = "client";
    ActorType["ADMIN"] = "admin";
    ActorType["SYSTEM_PROCESS"] = "system_process";
    ActorType["TOOL"] = "tool";
})(ActorType || (ActorType = {}));
